import PropTypes from 'prop-types';
import { ContentNodeConfigurationPropType, ImagePropType, WebsiteComponentInteractionPropType } from '../../../services/proptypes';
export var ComponentConfigurationPropType = PropTypes.shape({
  componentIdentifier: PropTypes.string,
  files: PropTypes.arrayOf(ImagePropType),
  contentNodes: PropTypes.arrayOf(ContentNodeConfigurationPropType),
  interactions: PropTypes.arrayOf(WebsiteComponentInteractionPropType)
});
export var CuratedHeroVariantPropTypes = {
  componentConfigurations: PropTypes.arrayOf(ComponentConfigurationPropType)
};
export var CuratedHeroVariantDefaultProps = {
  componentConfigurations: []
};